const StoreConfig = {
  category_url_suffix: '/',
  store_code: process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
  configurable_thumbnail_source: 'itself',
  product_url_suffix: '.html',
  available_countries: [
    {
      code: 'us',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/us.svg`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/us-mobile.svg`,
      name: 'United States',
      url: 'awbridal.com',
      currency: 'USD',
      language: 'English',
    },
    {
      code: 'uk',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/gb.svg`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/gb-mobile.svg`,
      name: 'United Kingdom',
      url: 'awbridal.co.uk',
      currency: 'GBP',
      language: 'English',
    },
    {
      code: 'ca',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/ca.svg`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/ca-mobile.svg`,
      name: 'Canada',
      url: 'awbridal.ca',
      currency: 'CAD',
      language: 'English',
    },
    {
      code: 'au',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/au.svg`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/au-mobile.svg`,
      name: 'Australia',
      url: 'awbridal.com/au',
      currency: 'AUD',
      language: 'English',
    },
    {
      code: 'de',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/de.svg`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/de-mobile.svg`,
      name: 'Germany',
      url: 'awbridal.com/de',
      currency: 'EUR',
      language: 'Deutsch',
    },
    {
      code: 'fr',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/fr.svg`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/fr-mobile.svg`,
      name: 'France',
      url: 'awbridal.com/fr',
      currency: 'EUR',
      language: 'French',
    },
    {
      code: 'ie',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/ie.svg`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/ie-mobile.svg`,
      name: 'Ireland',
      url: `awbridal.com/ie`,
      currency: 'EUR',
      language: 'English',
    },
    {
      code: 'it',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/it.svg`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/it-mobile.svg`,
      name: 'Italy',
      url: `awbridal.com/it`,
      currency: 'EUR',
      language: 'Italian',
    },
    {
      code: 'nz',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/nz.svg`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}icons/nz-mobile.svg`,
      name: 'New Zealand',
      url: `awbridal.com/nz`,
      currency: 'NZD',
      language: 'English',
    },
  ],
  // 修改地址时使用
  default_country_code: process.env.NEXT_PUBLIC_DEFAULT_COUNTRY_CODE,
  // 跳转多语言网站时使用
  current_country_code: process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
  currency: {
    current_currency_code: process.env.NEXT_PUBLIC_DEFAULT_DISPLAY_CURRENCY_CODE,
    default_display_currency_code: process.env.NEXT_PUBLIC_DEFAULT_DISPLAY_CURRENCY_CODE,
    available_currency_codes: ['AUD', 'GBP', 'CAD', 'USD', 'NZD'],
  },
};

export default StoreConfig;
